import React, { Component } from "react";
import UploadImage from "../Components/ImageManager/UploadImage";
import EditImage from "../Components/ImageManager/EditImage";
import ResetImage from "../Components/ImageManager/ResetImage";
import classNames from "classnames";

var windowValues = [];
var matPrint = [];

class Sizes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      update: false,
      error: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handler = this.handler.bind(this);
    this.selectPrint = this.selectPrint.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.selectedmatBoard !== this.props.selectedmatBoard) {
      this.setSizeState();
    }
  }

  handler(id, uploadedFile, file) {
    windowValues[id]["uploadedFile"] = uploadedFile;
    if (file !== "") {
      windowValues[id]["uploadedFileWidth"] = file.width;
      windowValues[id]["uploadedFileHeight"] = file.height;
    }
    this.changeSize(id);
  }

  updateSizeState() {
    //console.log(windowValues)
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        windowSizes: windowValues,
        matWindowUpdated: this.props.matWindowUpdated === 1 ? 0 : 1,
      },
    });
  }

  setSizeState() {
    const { selectedmatBoard } = this.props;
    windowValues = [];
    matPrint = [];
    for (var i = 0; i < selectedmatBoard.get("number_of_windows"); i++) {
      const height = selectedmatBoard.getIn(["mat_data", i, "height"]);
      const width = selectedmatBoard.getIn(["mat_data", i, "width"]);
      const xData = selectedmatBoard.getIn(["mat_data", i, "x"]);
      const yData = selectedmatBoard.getIn(["mat_data", i, "y"]);

      windowValues.push({
        width: width,
        height: height,
        uploadedFile: "", //http://localhost:3000/ducklings.jpg
        uploadedFileWidth: "",
        uploadedFileHeight: "",
        x: xData,
        y: yData,
      });

      matPrint.push({
        print: "no",
      });
    }

    this.props.dispatch({
      type: "SET_STATE",
      state: {
        windowSizes: windowValues,
        updatingWindow: 0,
      },
    });
  }

  handleChange(e) {
    const target = e.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (parseFloat(value) <= 0 || value === "") value = 0;

    const splitName = name.split("_");

    if (splitName[0] === "width") windowValues[splitName[1]]["width"] = value;

    if (splitName[0] === "height") windowValues[splitName[1]]["height"] = value;

    if (splitName[0] === "left") windowValues[splitName[1]]["x"] = value;

    if (splitName[0] === "top") windowValues[splitName[1]]["y"] = value;

    //console.log(windowValues, 'windowValues')

    this.props.dispatch({
      type: "SET_STATE",
      state: {
        updatingWindow: splitName[1],
        windowSizes: windowValues,
        matWindowUpdated: this.props.matWindowUpdated === 1 ? 0 : 1,
      },
    });
  }

  changeSize = (id) => {
    const { windowDimensionW, windowDimensionH } = this.props;

    if (
      parseFloat(windowValues[id]["width"]) > parseFloat(windowDimensionW) ||
      parseFloat(windowValues[id]["height"]) > parseFloat(windowDimensionH)
    ) {
      this.setState({ error: true });
    } else {
      this.setState({ error: false });
      this.props.dispatch({
        type: "SET_STATE",
        state: {
          updatingWindow: id,
        },
      });
      this.updateSizeState();
    }
  };

  selectPrint(e) {
    const { printing } = this.props;
    var self = this;
    let printYes = false;

    const val = e.currentTarget.value;
    const matches = val.match(/(\d+)/);
    matPrint[matches[0]]["print"] = val;

    //console.log('matches:' + matches[0])
    /* console.log(matPrint[matches[0]]['print'])
		console.log(matPrint) */

    for (var i = 0; i < matPrint.length; i++) {
      //console.log(matPrint[i]['print'])
      if (matPrint[i]["print"] === "yes" + i) {
        printYes = true;
      }
    }

    if (printing.size > 0 && printYes) {
      printing
        .filter((print) => "High Gloss" === print.getIn(["title", "rendered"]))
        .map((print) => self.dispatchSelectPrint(print.get("id")));
    } else {
      printing
        .filter(
          (print) =>
            "No Printing Required" === print.getIn(["title", "rendered"])
        )
        .map((print) => self.dispatchSelectPrint(print.get("id")));
    }

    this.props.dispatch({
      type: "SET_STATE",
      state: {
        matPrint: matPrint,
      },
    });
  }

  dispatchSelectPrint(Print) {
    const sData = Print;
    this.props.dispatch({
      type: "SET_STATE",
      state: {
        selectedPrint: sData,
      },
    });
  }

  createWindowSizes = () => {
    const {
      selectedmatBoard,
      matWindowValues,
      updatingWindow,
      selectedPrintName,
    } = this.props;
    let Windows = [];
    if (selectedmatBoard) {
      // console.log(selectedmatBoard, "selectedmatBoard")
      // console.log(parseFloat(selectedmatBoard.get('number_of_windows')), "matBoardWindowSize")
      // console.log(windowValues, "windowValues")
      // console.log(updatingWindow, "updatingWindow")

      if (
        parseFloat(selectedmatBoard.get("number_of_windows")) !==
        windowValues.length
      )
        return "";

      for (
        let i = 0;
        i < parseFloat(selectedmatBoard.get("number_of_windows"));
        i++
      ) {
        const matWindowSizeWidth = parseFloat(windowValues[i]["width"]);
        const matWindowSizeHeight = parseFloat(windowValues[i]["height"]);
        const matWindowSizeLeft = parseFloat(windowValues[i]["x"]);
        const matWindowSizeTop = parseFloat(windowValues[i]["y"]);

        //const uploadedFile = windowSizes.getIn([i, 'uploadedFile']);

        if (
          isNaN(matWindowSizeWidth) ||
          isNaN(matWindowSizeHeight) ||
          isNaN(matWindowSizeLeft) ||
          isNaN(matWindowSizeTop)
        )
          return;

        //console.log(updatingWindow, "updatingWindow")

        Windows.push(
          <div className="col-sm-6" key={i}>
            <div
              className={classNames(
                "sizes-inner col-sm-12",
                updatingWindow === i && "selected-window-outer"
              )}
            >
              <ul>
                <li className="frame-size-li">
                  <p className={updatingWindow === i ? "selected-window" : ""}>
                    Window {i + 1}:
                  </p>
                </li>
                <li>
                  <label>Width</label>
                  <div className="quantity">
                    <input
                      type="number"
                      name={"width_" + i}
                      onChange={this.handleChange}
                      value={matWindowSizeWidth}
                    />
                  </div>
                </li>
                <li>
                  <label>Height</label>
                  <div className="quantity">
                    <input
                      type="number"
                      name={"height_" + i}
                      onChange={this.handleChange}
                      value={matWindowSizeHeight}
                    />
                  </div>
                </li>
                <li>
                  <label>Left</label>
                  <div className="quantity">
                    <input
                      type="number"
                      name={"left_" + i}
                      onChange={this.handleChange}
                      value={matWindowSizeLeft}
                    />
                  </div>
                </li>
                <li>
                  <label>Top</label>
                  <div className="quantity">
                    <input
                      type="number"
                      name={"top_" + i}
                      onChange={this.handleChange}
                      value={matWindowSizeTop}
                    />
                  </div>
                </li>
                {/* <li className="m-t-20">
									<input type="button" value="Change Size" onClick={this.changeSize.bind(this, i)} className="btn btn-primary default-btn" />
								</li> */}
              </ul>
              <div className="upload_image">
                <ul>
                  <UploadImage {...this.props} handler={this.handler} id={i} />
                  <EditImage {...this.props} handler={this.handler} id={i} />
                  <ResetImage {...this.props} handler={this.handler} id={i} />
                </ul>
                <ul className="printingForWindows">
                  <li className="frame-size-li printingForWindows-li">
                    <p>Printing</p>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name={"printing" + i}
                      value={"yes" + i}
                      onChange={this.selectPrint}
                      checked={
                        selectedPrintName !== "No Printing Required"
                          ? true
                          : false
                      }
                    />
                    <label
                      className="printingForWindows-label"
                      htmlFor={"yes" + i}
                    >
                      Yes
                    </label>
                  </li>
                  <li>
                    <input
                      type="radio"
                      name={"printing" + i}
                      value={"no" + i}
                      onChange={this.selectPrint}
                      checked={
                        selectedPrintName === "No Printing Required"
                          ? true
                          : false
                      }
                    />
                    <label
                      className="printingForWindows-label"
                      htmlFor={"no" + i}
                    >
                      No
                    </label>
                  </li>
                </ul>
                {matWindowValues.size > 0 && (
                  <ul className="matWindowValues">
                    <li className="frame-size-li printingForWindows-li">
                      <p>Dimensions</p>
                    </li>
                    <li>
                      <p>
                        <strong>Width: </strong>
                        {matWindowValues.getIn([i, "width"])}cm
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Height: </strong>
                        {matWindowValues.getIn([i, "height"])}cm
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Left: </strong>
                        {matWindowValues.getIn([i, "left"])}cm
                      </p>
                    </li>
                    <li>
                      <p>
                        <strong>Top: </strong>
                        {matWindowValues.getIn([i, "top"])}cm
                      </p>
                    </li>
                  </ul>
                )}
              </div>
            </div>
            <div className="h-size30 clear"></div>
          </div>
        );
      }
      return Windows;
    }
  };

  render() {
    const {
      updatingWindow,
      title,
      hasUpdate,
      matWindowValues,
      selectedPrintName,
    } = this.props;
    const { error } = this.state;
    //console.log(hasUpdate, "hasUpdate")
    if (windowValues.length > 0) {
      const updatingWindowVar = parseFloat(updatingWindow);
      const matWindowSizeWidth = parseFloat(
        windowValues[updatingWindowVar]["width"]
      );
      const matWindowSizeHeight = parseFloat(
        windowValues[updatingWindowVar]["height"]
      );
      const matWindowSizeLeft = parseFloat(
        windowValues[updatingWindowVar]["x"]
      );
      const matWindowSizeTop = parseFloat(windowValues[updatingWindowVar]["y"]);
      //console.log(matWindowSizeWidth, "matWindowSizeWidth");
      return (
        <div
          className={classNames(
            "top_cont",
            "sizes-wrapper",
            hasUpdate ? "under_the_image" : ""
          )}
        >
          {title && (
            <div className="tit sizes-title">
              <h4>
                For each window enter your window size and upload an image if
                required
              </h4>
            </div>
          )}
          {error && (
            <div className="alert alert-danger clear m-t-0 m-b-10">
              Window size cannot be greater then the matt overall size.
            </div>
          )}
          <div className="row">
            {hasUpdate ? (
              <div className="col-sm-12">
                <div
                  className={classNames(
                    "sizes-inner col-sm-12",
                    "selected-window-outer"
                  )}
                >
                  <ul>
                    <li className="frame-size-li">
                      <p className={"selected-window"}>
                        Window {updatingWindowVar + 1}:
                      </p>
                    </li>
                    <li>
                      <label>Width</label>
                      <div className="quantity">
                        <input
                          type="number"
                          name={"width_" + updatingWindowVar}
                          onChange={this.handleChange}
                          value={matWindowSizeWidth}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Height</label>
                      <div className="quantity">
                        <input
                          type="number"
                          name={"height_" + updatingWindowVar}
                          onChange={this.handleChange}
                          value={matWindowSizeHeight}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Left</label>
                      <div className="quantity">
                        <input
                          type="number"
                          name={"left_" + updatingWindowVar}
                          onChange={this.handleChange}
                          value={matWindowSizeLeft}
                        />
                      </div>
                    </li>
                    <li>
                      <label>Top</label>
                      <div className="quantity">
                        <input
                          type="number"
                          name={"top_" + updatingWindowVar}
                          onChange={this.handleChange}
                          value={matWindowSizeTop}
                        />
                      </div>
                    </li>
                  </ul>
                  <div className="upload_image">
                    <ul>
                      <UploadImage
                        {...this.props}
                        handler={this.handler}
                        id={updatingWindowVar}
                      />
                      <EditImage
                        {...this.props}
                        handler={this.handler}
                        id={updatingWindowVar}
                      />
                      <ResetImage
                        {...this.props}
                        handler={this.handler}
                        id={updatingWindowVar}
                      />
                    </ul>
                    <ul className="printingForWindows">
                      <li className="frame-size-li printingForWindows-li">
                        <p>Printing</p>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name={"printing" + updatingWindowVar}
                          value={"yes" + updatingWindowVar}
                          onChange={this.selectPrint}
                          checked={
                            selectedPrintName !== "No Printing Required"
                              ? true
                              : false
                          }
                        />
                        <label
                          className="printingForWindows-label"
                          htmlFor={"yes" + updatingWindowVar}
                        >
                          Yes
                        </label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          name={"printing" + updatingWindowVar}
                          value={"no" + updatingWindowVar}
                          onChange={this.selectPrint}
                          checked={
                            selectedPrintName === "No Printing Required"
                              ? true
                              : false
                          }
                        />
                        <label
                          className="printingForWindows-label"
                          htmlFor={"no" + updatingWindowVar}
                        >
                          No
                        </label>
                      </li>
                    </ul>
                    {matWindowValues.size > 0 && (
                      <ul className="matWindowValues">
                        <li className="frame-size-li printingForWindows-li">
                          <p>Dimensions</p>
                        </li>
                        <li>
                          <p>
                            <strong>Width: </strong>
                            {matWindowValues.getIn([
                              updatingWindowVar,
                              "width",
                            ])}
                            cm
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Height: </strong>
                            {matWindowValues.getIn([
                              updatingWindowVar,
                              "height",
                            ])}
                            cm
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Left: </strong>
                            {matWindowValues.getIn([updatingWindowVar, "left"])}
                            cm
                          </p>
                        </li>
                        <li>
                          <p>
                            <strong>Top: </strong>
                            {matWindowValues.getIn([updatingWindowVar, "top"])}
                            cm
                          </p>
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              this.createWindowSizes()
            )}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default Sizes;
